import React from 'react';
import Collapsible from 'components/Collapsible';
import {
	Wrapper,
	Header,
	TitleWrapper,
	Title,
	TableList,
	NoData,
} from './RegionalData.styles';
import { RegionalTableContainer } from '../RegionalTable';
import { ApButtonIcon, ApMenu, ApMenuItem } from '@alixpartners/ui-components';
import {
	SPEND_BY_LABELS,
	SPEND_BY_LABELS_PLURAL,
	EXPORT_OPTIONS,
	makeUnknownFromEmpty,
} from '../../utils';
import { getFormattedSpendWithSymbol } from 'utils/number';

export const RegionalData = ({
	data,
	currencySymbol,
	selectedCountry,
	selectedState,
	queryParams,
	spendType,
	dimension,
	onExport,
	showExplorePage,
	spendBy,
	selectedItem,
	hideDecimals
}) => {
	const spendFormatter = value => {
		return value
			? getFormattedSpendWithSymbol(value, currencySymbol, hideDecimals).toUpperCase()
			: '-';
	};
	return (
		<Wrapper>
			{data.length !== 0 && (
				<Header>
					<TitleWrapper>
						<Title>Regions</Title>
					</TitleWrapper>
					<ApMenu button={<ApButtonIcon iconName="download" />}>
						<ApMenuItem onClick={onExport}>
							{EXPORT_OPTIONS[1].label}
						</ApMenuItem>
					</ApMenu>
				</Header>
			)}
			{data.length !== 0 ? (
				<TableList>
					{data.map(({ name, count, spend }) => {
						const labelMap =
							count === 1 ? SPEND_BY_LABELS : SPEND_BY_LABELS_PLURAL;
						const description = `${count} ${labelMap[
							spendBy
						].toLowerCase()} / ${spendFormatter(spend)} of spend`;

						return (
							<Collapsible key={makeUnknownFromEmpty(name)} header={makeUnknownFromEmpty(name)} subheader={description}>
								<RegionalTableContainer
									selectedCountry={selectedCountry}
									selectedState={selectedState}
									currencySymbol={currencySymbol}
									queryParams={queryParams}
									spendType={spendType}
									dimension={dimension}
									region={name}
									showExplorePage={showExplorePage}
									spendBy={spendBy}
									selectedItem={selectedItem}
									hideDecimals={hideDecimals}
								/>
							</Collapsible>
						);
					})}
				</TableList>
			) : (
				<NoData>No data found</NoData>
			)}
		</Wrapper>
	);
};

export default RegionalData;
